<template>
  <div class="flex h-[440px]">
    <div class="relative h-[95%] !ml-2">
      <div
        :class="[{ '!w-0 !h-0 translate-y-[400px] -translate-x-[20px] mt-auto !opacity-0': left_box_collapsed }]"
        class="w-[220px] h-full transition-all duration-500 ease-in-out shadow-lg shadow-purple-500/40 flex flex-col rounded-xl bg-gradient-to-b from-[#2DA7D7] to-[#841FF4]">
        <button class="btn cancel-btn bg-white w-[90%] mt-8 text-start justify-start">
          <NewAIConvoIcon color_1="#2DA7D7" color_2="#841FF4" class="mr-3" />
          <span class="text-transparent bg-clip-text bg-gradient-to-b from-[#2DA7D7] to-[#841FF4]">{{ $t("New Conversation") }} </span>
        </button>

        <div>
          <PromptLeftBox :selected-item="selectedItem" />
        </div>
        <div
          class="mt-auto mr-2 mb-1 ml-auto cursor-pointer flex items-center space-x-2 group text-white"
          @click="left_box_collapsed = true">
          <div>{{ $t("Collapse") }}</div>
          <AICollapseIcon class="w-5 h-5 group-hover:scale-125 transition ease-in-out" />
        </div>
      </div>
      <div
        :class="[{ 'opacity-100 pointer-events-auto !delay-opacity-500': left_box_collapsed }]"
        class="mt-auto cursor-pointer items-center justify-center w-8 flex h-8 rounded-full hover:scale-125 pointer-events-none bg-gradient-to-r from-[#2DA7D7] to-[#841FF4] shadow-md shadow-purple-500 absolute right-2 bottom-0 opacity-0 transition duration-500 ease-in-out"
        @click="left_box_collapsed = false">
        <AIExpandIcon class="w-6 h-6" />
      </div>
    </div>
    <div
      class="w-[740px] !ml-2 !mr-1 h-[95%] shadow-lg shadow-purple-500/40 rounded-xl bg-gradient-to-b overflow-hidden from-[#2DA7D7] to-[#841FF4]">
      <div class="bg-white w-[99.2%] ml-[0.4%] h-[98.5%] mt-[0.5%] rounded-lg relative overflow-visible">
        <div class="p-0 h-full">
          <PromptRightBox :selected-item="selectedItem" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewAIConvoIcon from "@/components/shared/icons/NewAIConvoIcon"

import PromptLeftBox from "./PromptLeftBox.vue"
import PromptRightBox from "./PromptRightBox.vue"

import AICollapseIcon from "@/components/shared/icons/AICollapseIcon"
import AIExpandIcon from "@/components/shared/icons/AIExpandIcon"

export default {
  components: { NewAIConvoIcon, AICollapseIcon, AIExpandIcon, PromptLeftBox, PromptRightBox },
  props: {
    selectedItem: null
  },
  emits: [],
  data() {
    return {
      left_box_collapsed: false
    }
  },
  watch: {},

  created() {},

  methods: {}
}
</script>
